// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__17mA8","modalFooterButton":"ModalNotes_modalFooterButton__1nTEo"};